// Display-safe AI summaries.
// The bot-leg summariser can emit low-confidence admissions ("the conversation
// log does not contain enough information…") when it had no transcript to work
// with. Those must never reach an agent's screen — hide in lists, neutral
// fallback in the handover panel. Root cause (convoLog drop) patched
// 2026-08-21; this is defence-in-depth plus cleanup of stale records.
const FAILURE_PATTERNS = [
  /does not contain enough information/i,
  /not enough information/i,
  /unable to determine/i,
  /insufficient (information|context)/i,
  /only captures the tail end/i,
  /no record of what/i,
];

export function displaySummary(text) {
  if (!text || !String(text).trim()) return null;
  const t = String(text).trim();
  return FAILURE_PATTERNS.some(re => re.test(t)) ? null : t;
}
